<template>
    <div class="report-comment">
        <span class="question" for="">
            <slot name="title"></slot>
            <br />
            <span class="total-answers">{{ answers.length }} {{ $root.t('forms-report_component-answers') }}</span>
        </span>
        <div class="clear"></div>
        <div class="lightbox" v-bind:class="{ active: lightbox }">
            <div class="backdrop" @click="lightbox = false"></div>
            <div
                class="far fa-times close"
                @click.prevent.stop="lightbox = false"
            ></div>
            <div class="content">
                <span class="question" for="">
                    <slot name="title"></slot>
                    <br />
                    <span class="total-answers"
                        >{{ answers.length }} {{ $root.t('forms-report_component-answers') }}</span
                    >
                </span>
                <div class="answers">
                    <div class="clear"></div>
                    <div
                        class="answer"
                        v-for="answer in answers"
                        :key="answer.id"
                    >
                        <div
                            class="name-date"
                            @click.prevent="goToInbox(answer)"
                            :class="gradeClass(answer.grade)"
                        >
                            <span class="name">
                                <btn-whatsapp
                                    :number="answer.whatsapp"
                                ></btn-whatsapp>
                                <a href="#">{{ answer.name }}</a>
                            </span>
                            <span class="grade">{{ answer.grade }}</span>
                            <span
                                v-if="answer.places_branches_id"
                                class="place"
                            >
                                -
                                {{
                                    placeBranch(answer.places_branches_id)
                                }}</span
                            >
                            <br /><human-date class="date" :date="answer.created" :format="t('dates-format_date_time_seconds')" />
                        </div>
                        <p
                            class="answer-text"
                            v-html="formatText(answer.valueText)"
                        ></p>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="hasAnswers">
            <div class="answers">
                <div
                    class="answer"
                    v-for="answer in previewAnswers"
                    :key="answer.id"
                >
                    <div
                        class="name-date"
                        @click.prevent="goToInbox(answer)"
                        :class="gradeClass(answer.grade)"
                    >
                        <span class="name">
                            <btn-whatsapp
                                :number="answer.whatsapp"
                            ></btn-whatsapp>
                            <a href="#">{{ answer.name }}</a>
                        </span>
                        <span class="grade">{{ answer.grade }}</span>
                        <span v-if="answer.places_branches_id" class="place">
                            - {{ placeBranch(answer.places_branches_id) }}</span
                        >
                        <br /><human-date class="date" :date="answer.created" :format="t('dates-format_date_time_seconds')" />
                    </div>
                    <p
                        class="answer-text"
                        v-html="formatText(answer.valueText)"
                    ></p>
                </div>
            </div>
            <button
                class="btn btn-primary see-more"
                @click.prevent="lightbox = !lightbox"
            >
                {{ $root.t('forms-report_component-see_all_answers') }}
            </button>
        </template>
        <span class="no-answers" v-if="!hasAnswers">
            {{ $root.t('forms-report_component-no_answers') }}</span
        >
    </div>
</template>
<script>
import HumanDate from "../../components/human-date/human-date.vue";

export default {
    components: { HumanDate },
    props: {
        answers: Array,
        gradeClassMethod: Function,
    },
    data: function () {
        return {
            lightbox: false,
        };
    },
    computed: {
        hasAnswers: function () {
            return this.answers.length > 0;
        },
        previewAnswers: function () {
            let previewAnswers = [];
            for (var i = 0; i < this.answers.length; i++) {
                let answer = Object.assign({}, this.answers[i]);
                answer.valueText =
                    answer.valueText.length > 200
                        ? answer.valueText.substr(0, 197) + "..."
                        : answer.valueText;
                previewAnswers.push(answer);
                if (i === 1) {
                    break;
                }
            }
            return previewAnswers;
        },
        gradeClass: function () {
            return this.gradeClassMethod;
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        formatText: function (text) {
            return text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        },
        placeBranch: function (id) {
            if (this.$root.place.branches.length > 0) {
                let branch = this.$root.place.branches.find(
                    (branch) => branch.id == id,
                );
                return branch ? branch.title : "";
            }
            return "";
        },
        goToInbox(answer) {
            this.$router.push({
                path: "/inbox",
                query: {
                    filter: JSON.stringify({ client: answer.clients_id }),
                    message_id: answer.answers_id,
                },
            });
        },
    },
};
</script>
